import { getRequest, postRequest, deleteRequest } from "../../shared/api/axiosHandler";

export const addToWishlist = async (productId) => {
    try {
        //window.dispatchEvent(new Event("wishlistUpdated"));
        return await postRequest("/api/v1/wishlist", { productId }, true);
    } catch (error) {
        throw error;
    }
}

export const getWishlist = async () => {

    try {

        return await getRequest("/api/v1/wishlist", {}, true);
    } catch (error) {
        throw error;
    }
}

export const removeFromWishlist = async (productId) => {
    try {
        //window.dispatchEvent(new Event("wishlistUpdated"));
        return await deleteRequest(`/api/v1/wishlist/${productId}`, {}, true);
    } catch (error) {
        throw error;
    }
}

export const clearWishlist = async () => {
    try {
        //window.dispatchEvent(new Event("wishlistUpdated"));
        return await deleteRequest("/api/v1/wishlist", {}, true);
    } catch (error) {
        throw error;
    }
}
